module.exports = __webpack_public_path__ + "static/media/RM007_COVER1_FORPRINT_compressed-09.350755e9.jpg";